import apisauce from "apisauce";

/**
 * API service — apisauce-based client matching the appointo_client pattern.
 */
export default {
  create: () => {
    const api = apisauce.create({
      baseURL: process.env.BASE_URL || "/api/v1",
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 30000,
    });

    // ---- Auth header helpers (same interface as appointo_client) ----

    const setAuthToken = (token) => {
      api.setHeader("Authorization", `Bearer ${token}`);
    };

    const removeAuthToken = () => {
      api.deleteHeader("Authorization");
    };

    return {
      // Helpers
      setAuthToken,
      removeAuthToken,

      // Auth
      login: (params) => api.post("auth/login", params),
      signup: (params) => api.post("auth/signup", params),
      me: () => api.get("users/me"),

      // Google Search Console
      listGoogleSites: () => api.get("google/sites"),

      // Reports
      listReports: () => api.get("reports"),
      getReport: (token) => api.get(`reports/${token}`),

      // Teaser (free preview)
      getTeaser: () => api.get("teaser"),
      createTeaser: (site_url) => api.post("teaser", { site_url }),

      // Checkout (pass `report_token` to resume a pending report,
      // or `site_url` to create a brand new one)
      createCheckout: (params) => api.post("checkout", params),
    };
  },
};
